import { motion } from "framer-motion";
import { CalendarCheck, CheckCircle, Car } from "lucide-react";

const HowItWorksSection = () => {
  const steps = [
    {
      icon: CalendarCheck,
      title: "Book in Advance",
      description: "Select date and time. Get an instant fare.\nNo surprises, no surge pricing.",
    },
    {
      icon: CheckCircle,
      title: "Get Confirmed",
      description: "Your booking is confirmed via WhatsApp,\nwith driver details shared within 30 minutes.",
    },
    {
      icon: Car,
      title: "Enjoy a smooth ride.",
      description: "Your driver arrives 15 minutes early,\nso you're always on time.",
    },
  ];

  return (
    <section id="how-it-works" className="py-16 sm:py-20 bg-sarathi-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <span className="text-sarathi-primary font-semibold text-xs tracking-widest uppercase">
            How It Works
          </span>
          <h2 className="font-outfit text-2xl sm:text-3xl font-bold tracking-tight text-white mt-3 mb-3">
            Three steps. Zero stress.
          </h2>
        </motion.div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
              className="relative"
            >
              {/* Connector Line (hidden on mobile, visible on desktop) */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-10 left-[calc(50%+40px)] w-[calc(100%-40px)] h-[2px] bg-gradient-to-r from-sarathi-primary/50 to-sarathi-primary/10"></div>
              )}
              
              <div className="text-center">
                {/* Step Number & Icon */}
                <div className="relative inline-flex items-center justify-center mb-5">
                  <div className="w-20 h-20 bg-sarathi-background border-2 border-sarathi-primary/30 rounded-2xl flex items-center justify-center">
                    <step.icon className="w-8 h-8 text-sarathi-primary" />
                  </div>
                  {/* Step Number Badge */}
                  <div className="absolute -top-2 -right-2 w-7 h-7 bg-sarathi-primary rounded-full flex items-center justify-center">
                    <span className="text-white text-sm font-bold">{index + 1}</span>
                  </div>
                </div>
                
                {/* Content */}
                <h3 className="font-outfit text-lg font-bold text-white mb-2">
                  {step.title}
                </h3>
                <p className="text-sarathi-text-secondary text-sm leading-relaxed max-w-xs mx-auto whitespace-pre-line">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
